import Swiper from 'swiper/bundle';
if (typeof window !== 'undefined') window.Swiper = Swiper;

export default {
    initSwiper(element) {
        const swiperElement = typeof element === 'string' ? document.querySelector(element) : element;

        const fallbackOptions = {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 2.5,
            spaceBetween: 10
        };
        const options = swiperElement.dataset.swiper ? JSON.parse(swiperElement.dataset.swiper) : fallbackOptions;

        const a = new Swiper(swiperElement, options);
        return a;
    },
    hello() {
        console.log('Hello from swiper.js');
    }
};
